export default {
  methods: {
    beginEdit () {
      if (!this.activeMap && this.workflowView === 'live') return
      const rows = (this.workflowView === 'live' ? this.selectedSpawns : (this.activeBatch ? this.activeBatch.spawns : [])) || []
      this.editRows = rows.map(row => this.normalizeEditableSpawn(this.cloneSpawn(row)))
      if (rows.length) {
        const defaults = this.defaultLevelRangeForRows(rows)
        this.setDraftLevelRange(defaults.min, defaults.max)
      } else {
        this.setDraftLevelRange('', '')
      }
      this.editMode = true
      this.workflowStackedMaps = false
    },
    cancelEdit () {
      if (this.editMode && !this.confirmDiscardEdit()) return
      this.discardEdit()
    },
    confirmDiscardEdit () {
      return window.confirm('All unsaved spawn changes will be lost. Continue?')
    },
    discardEdit () {
      this.editMode = false
      this.editRows = []
      this.addSpawnModal.visible = false
      this.addSpawnModal.existingTimeOverrides = {}
    },
    discardDraftChanges () {
      if (!this.editMode) return
      this.editRows = this.originalEditRows.map(row => this.normalizeEditableSpawn(this.cloneSpawn(row)))
      if (this.editRows.length) {
        const defaults = this.defaultLevelRangeForRows(this.editRows)
        this.setDraftLevelRange(defaults.min, defaults.max)
      } else {
        this.setDraftLevelRange('', '')
      }
      this.clearRepelCache()
      this.clearMoveAnalysisCache()
    },
    cloneSpawn (spawn) {
      return JSON.parse(JSON.stringify(spawn || {}))
    },
    normalizeEditableSpawn (spawn) {
      const row = spawn || {}
      row.minLVL = this.clampNumber(row.minLVL, 1, 100)
      row.maxLVL = Math.max(this.clampNumber(row.maxLVL, 1, 100), row.minLVL)
      row.rarity = this.clampDecimalInputValue(row.rarity, 0, 1)
      row.itemRarity = Number(row.itemID || 0) > 0 ? this.clampDecimalInputValue(row.itemRarity, 0, 1) : 0
      row._minLVLInput = String(row.minLVL)
      row._maxLVLInput = String(row.maxLVL)
      return row
    },
    ownWorkspaceBatchForMap (mapName) {
      const normalized = String(mapName || '').trim().toLowerCase()
      if (!normalized) return null
      return (this.workflowBatches || []).find(batch => batch.isOwner && batch.status === 'wip' && String(batch.mapName || '').trim().toLowerCase() === normalized) || null
    },
    spawnRowsSignature (rows) {
      return JSON.stringify((rows || []).map(row => {
        const mapName = this.activeMap || (this.activeBatch && this.activeBatch.mapName) || row.map || ''
        const prepared = this.prepareSpawnForSave(row, mapName)
        return {
          area: prepared.area,
          dexID: Number(prepared.dexID || 0),
          minLVL: Number(prepared.minLVL || 0),
          maxLVL: Number(prepared.maxLVL || 0),
          itemID: Number(prepared.itemID || 0),
          itemRarity: Number(prepared.itemRarity || 0),
          memberOnly: !!prepared.memberOnly,
          rarity: Number(prepared.rarity || 0),
          required_rod: Number(prepared.required_rod || 0),
          start: Number(prepared.start || 0),
          end: Number(prepared.end || 0),
          forms: String(prepared.forms || '0'),
          formRarity: Number(prepared.formRarity || 0),
          fishOnly: this.isFishingOnly(prepared)
        }
      }).sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b))))
    },
    saveDraft () {
      if (!this.editMode || this.saveDraftDisabled) return
      const mapName = this.activeMap || (this.activeBatch && this.activeBatch.mapName) || ''
      if (!mapName) return
      if (this.hasEditLevelInputErrors) {
        window.alert('Cannot save. Fix invalid Level Range inputs first.')
        return
      }
      const missingTimeSpawns = this.editRows.filter(row => !this.activeTimeKeys(row).length)
      if (missingTimeSpawns.length) {
        const names = missingTimeSpawns
          .map(row => this.pokemonName(row))
          .filter((name, index, list) => list.indexOf(name) === index)
        window.alert('Cannot save. The following Pokemon have no time selected: ' + names.join(', ') + '.')
        return
      }
      let id = this.workflowView === 'wip' && this.activeBatch ? this.activeBatch.id : 0
      let overwriteWorkspace = false
      if (this.workflowView === 'live') {
        const existing = this.ownWorkspaceBatchForMap(mapName)
        if (existing) {
          if (!window.confirm('You already have this map in Workspace. Overwrite the Workspace map?')) {
            return
          }
          id = existing.id
          overwriteWorkspace = true
        }
      }
      const payload = {
        id,
        mapName,
        overwriteWorkspace,
        spawns: this.editRows.map(row => this.prepareSpawnForSave(row, mapName))
      }
      this.pendingDraftSave = {
        id,
        mapName,
        overwriteWorkspace
      }
      this.pendingDraftSaveAck = null
      this.emit('saveSpawnDraft', payload)
    },
    handleSpawnDraftSaved (saved) {
      if (!this.pendingDraftSave || !saved) return
      const pendingMap = String(this.pendingDraftSave.mapName || '').trim()
      const savedMap = String(saved.mapName || '').trim()
      const pendingID = Number(this.pendingDraftSave.id || 0)
      const savedID = Number(saved.id || 0)
      if (pendingMap && savedMap && pendingMap !== savedMap) return
      if (pendingID > 0 && savedID > 0 && pendingID !== savedID) return
      this.pendingDraftSaveAck = {
        id: savedID,
        mapName: savedMap || pendingMap
      }
      this.finishPendingDraftSave()
    },
    finishPendingDraftSave () {
      if (!this.pendingDraftSaveAck) return
      const ack = this.pendingDraftSaveAck
      const savedBatch = (this.workflowBatches || []).find(batch => {
        if (!batch.isOwner || batch.status !== 'wip') return false
        if (Number(ack.id || 0) > 0 && Number(batch.id || 0) === Number(ack.id || 0)) return true
        return ack.mapName && String(batch.mapName || '') === String(ack.mapName || '')
      })
      if (!savedBatch) return
      this.pendingDraftSave = null
      this.pendingDraftSaveAck = null
      this.discardEdit()
      this.selectWorkflowBatch(savedBatch)
    },
    prepareSpawnForSave (spawn, mapName) {
      const row = this.cloneSpawn(spawn)
      const levelRange = this.normalizedLevelRangeForSpawn(row)
      row.map = mapName
      row.area = this.isWaterSpawn(row) ? 'surf' : 'land'
      row.minLVL = levelRange ? levelRange.min : this.clampNumber(row.minLVL, 1, 100)
      row.maxLVL = levelRange ? levelRange.max : Math.max(this.clampNumber(row.maxLVL, 1, 100), row.minLVL)
      if (this.censorRarityTiers) {
        delete row.rarity
      } else {
        row.rarity = Math.min(Math.max(Number(row.rarity || 0), 0), 1)
      }
      this.normalizeSpawnItemForSave(row)
      row.memberOnly = !!row.memberOnly
      row.start = this.clampNumber(row.start, 0, 23)
      row.end = this.clampNumber(row.end, 0, 23)
      row.steps = Number(row.steps || 15) || 15
      row.forms = row.forms || '0'
      row.formRarity = Number(row.formRarity || 0)
      delete row.noTimeSelected
      delete row._minLVLInput
      delete row._maxLVLInput
      if (!this.isWaterSpawn(row)) {
        row.required_rod = 0
      } else {
        row.required_rod = this.clampNumber(row.required_rod, 0, 3)
      }
      const fishOnly = row.fishOnly === undefined ? this.isFishingOnly(row) : row.fishOnly
      if (this.isWaterSpawn(row) && fishOnly) {
        row.x1 = 0
        row.x2 = 0
        row.y1 = 0
        row.y2 = 0
      } else {
        row.x1 = 0
        row.x2 = 300
        row.y1 = 0
        row.y2 = 300
      }
      delete row.fishOnly
      return row
    },
    clampNumber (value, min, max) {
      const number = Number(value || 0)
      if (!Number.isFinite(number)) return min
      return Math.min(Math.max(Math.round(number), min), max)
    },
    clampIntegerInputValue (value, min, max) {
      return this.clampNumber(value, min, max)
    },
    clampDecimalInputValue (value, min, max) {
      const number = Number(value || 0)
      if (!Number.isFinite(number)) return min
      return Math.min(Math.max(number, min), max)
    },
    parseLevelInput (value) {
      const text = String(value === undefined || value === null ? '' : value).trim()
      if (!/^\d+$/.test(text)) return null
      const number = Number(text)
      if (!Number.isInteger(number) || number < 1 || number > 100) return null
      return number
    },
    normalizedLevelRangeInputs (minInput, maxInput) {
      const min = this.parseLevelInput(minInput)
      const max = this.parseLevelInput(maxInput)
      if (min === null || max === null || min > max) return null
      return { min, max }
    },
    levelRangeInputState (minInput, maxInput, field) {
      const min = this.parseLevelInput(minInput)
      const max = this.parseLevelInput(maxInput)
      if (field === 'min' && min === null) return false
      if (field === 'max' && max === null) return false
      if (min !== null && max !== null && min > max) return false
      return null
    },
    normalizedLevelRangeForSpawn (spawn) {
      return this.normalizedLevelRangeInputs(this.spawnMinLevelInputValue(spawn), this.spawnMaxLevelInputValue(spawn))
    },
    validLevelRangeForSpawn (spawn) {
      return !!this.normalizedLevelRangeForSpawn(spawn)
    },
    normalizedDraftLevelRange () {
      return this.normalizedLevelRangeInputs(this.draftLevelMinInput, this.draftLevelMaxInput)
    },
    setDraftLevelRange (min, max) {
      this.draftLevelMinInput = min === '' || min === null || min === undefined ? '' : String(min)
      this.draftLevelMaxInput = max === '' || max === null || max === undefined ? '' : String(max)
      const range = this.normalizedDraftLevelRange()
      this.draftLevelMin = range ? range.min : null
      this.draftLevelMax = range ? range.max : null
    },
    setNativeInputValue (event, value) {
      if (!event || !event.target) return
      const text = String(value)
      if (event.target.value !== text) {
        event.target.value = text
      }
      this.$nextTick(() => {
        if (event.target && event.target.value !== text) {
          event.target.value = text
        }
      })
    },
    spawnMinLevelInputValue (spawn) {
      if (spawn && Object.prototype.hasOwnProperty.call(spawn, '_minLVLInput')) return String(spawn._minLVLInput)
      return String(this.clampIntegerInputValue(spawn.minLVL, 1, 100))
    },
    spawnMaxLevelInputValue (spawn) {
      if (spawn && Object.prototype.hasOwnProperty.call(spawn, '_maxLVLInput')) return String(spawn._maxLVLInput)
      return String(this.clampIntegerInputValue(spawn.maxLVL, 1, 100))
    },
    spawnMinLevelInputState (spawn) {
      return this.levelRangeInputState(this.spawnMinLevelInputValue(spawn), this.spawnMaxLevelInputValue(spawn), 'min')
    },
    spawnMaxLevelInputState (spawn) {
      return this.levelRangeInputState(this.spawnMinLevelInputValue(spawn), this.spawnMaxLevelInputValue(spawn), 'max')
    },
    spawnRarityInputValue (spawn) {
      const rarity = this.clampDecimalInputValue(spawn.rarity, 0, 1)
      return rarity.toFixed(6).replace(/0+$/, '').replace(/\.$/, '')
    },
    spawnItemDropChanceInputValue (spawn) {
      const chance = this.clampDecimalInputValue(Number(spawn.itemRarity || 0) * 100, 0, 100)
      return chance.toFixed(4).replace(/0+$/, '').replace(/\.$/, '')
    },
    setDraftMinLevel (value) {
      this.draftLevelMinInput = String(value === undefined || value === null ? '' : value)
      const range = this.normalizedDraftLevelRange()
      this.draftLevelMin = range ? range.min : null
      this.draftLevelMax = range ? range.max : null
    },
    setDraftMinLevelFromEvent (event) {
      this.setDraftMinLevel(event && event.target ? event.target.value : event)
    },
    setDraftMaxLevel (value) {
      this.draftLevelMaxInput = String(value === undefined || value === null ? '' : value)
      const range = this.normalizedDraftLevelRange()
      this.draftLevelMin = range ? range.min : null
      this.draftLevelMax = range ? range.max : null
    },
    setDraftMaxLevelFromEvent (event) {
      this.setDraftMaxLevel(event && event.target ? event.target.value : event)
    },
    setSpawnMinLevel (spawn, value) {
      const currentMax = this.clampNumber(spawn.maxLVL || 100, 1, 100)
      const min = Math.min(this.clampNumber(value, 1, 100), currentMax)
      this.$set(spawn, 'minLVL', min)
      if (Number(spawn.maxLVL || 0) < min) {
        this.$set(spawn, 'maxLVL', min)
      }
    },
    setSpawnMinLevelFromEvent (spawn, event) {
      const value = String(event && event.target ? event.target.value : event)
      this.$set(spawn, '_minLVLInput', value)
      const min = this.parseLevelInput(value)
      if (min !== null) {
        this.$set(spawn, 'minLVL', min)
      }
    },
    setSpawnMaxLevel (spawn, value) {
      const min = this.clampNumber(spawn.minLVL || 1, 1, 100)
      const max = Math.max(this.clampNumber(value, 1, 100), min)
      this.$set(spawn, 'minLVL', min)
      this.$set(spawn, 'maxLVL', max)
    },
    setSpawnMaxLevelFromEvent (spawn, event) {
      const value = String(event && event.target ? event.target.value : event)
      this.$set(spawn, '_maxLVLInput', value)
      const max = this.parseLevelInput(value)
      if (max !== null) {
        this.$set(spawn, 'maxLVL', max)
      }
    },
    setSpawnRarity (spawn, value) {
      this.$set(spawn, 'rarity', this.clampDecimalInputValue(value, 0, 1))
    },
    setSpawnRarityFromEvent (spawn, event) {
      const rarity = this.clampDecimalInputValue(event && event.target ? event.target.value : event, 0, 1)
      this.$set(spawn, 'rarity', rarity)
      this.setNativeInputValue(event, rarity.toFixed(6).replace(/0+$/, '').replace(/\.$/, ''))
    },
    normalizeLookupText (value) {
      return String(value || '').trim().toLowerCase()
    },
    itemOptionForName (name) {
      const key = this.normalizeLookupText(name)
      const id = this.itemIDByNormalizedName[key]
      if (!id) return null
      return {
        id,
        name: this.itemNameByID[String(id)] || String(name || '').trim()
      }
    },
    itemNameInputValue (spawn) {
      const text = String(spawn.item || '').trim()
      if (text) return text
      const id = Number(spawn.itemID || 0)
      return id > 0 ? this.itemNameByID[String(id)] || '' : ''
    },
    itemInputState (spawn) {
      const text = this.itemNameInputValue(spawn)
      if (!text) return null
      return !!this.itemOptionForName(text)
    },
    hasPredefinedItemDropChance (itemID) {
      const chances = this.referenceData && this.referenceData.itemDropChances ? this.referenceData.itemDropChances : {}
      return Object.prototype.hasOwnProperty.call(chances, String(Number(itemID || 0)))
    },
    predefinedItemDropChance (itemID) {
      const chances = this.referenceData && this.referenceData.itemDropChances ? this.referenceData.itemDropChances : {}
      return Number(chances[String(Number(itemID || 0))] || 0) / 100
    },
    setSpawnItemName (spawn, value) {
      const text = String(value || '').trim()
      const previousID = Number(spawn.itemID || 0)
      this.$set(spawn, 'item', text || null)
      if (!text) {
        this.$set(spawn, 'itemID', 0)
        this.$set(spawn, 'itemRarity', 0)
        return
      }

      const option = this.itemOptionForName(text)
      if (!option) {
        this.$set(spawn, 'itemID', 0)
        this.$set(spawn, 'itemRarity', 0)
        return
      }

      this.$set(spawn, 'itemID', option.id)
      this.$set(spawn, 'item', option.name)
      if (option.id !== previousID) {
        this.$set(spawn, 'itemRarity', this.hasPredefinedItemDropChance(option.id) ? this.predefinedItemDropChance(option.id) : 0)
      }
    },
    selectSpawnItemOption (spawn, item) {
      if (!item) return
      const id = Number(item.id || 0)
      const name = String(item.label || '').trim()
      if (!id || !name) return
      const previousID = Number(spawn.itemID || 0)
      this.$set(spawn, 'itemID', id)
      this.$set(spawn, 'item', name)
      if (id !== previousID) {
        this.$set(spawn, 'itemRarity', this.hasPredefinedItemDropChance(id) ? this.predefinedItemDropChance(id) : 0)
      }
    },
    setSpawnItemDropChance (spawn, value) {
      const chance = this.clampDecimalInputValue(value, 0, 100)
      this.$set(spawn, 'itemRarity', chance / 100)
    },
    setSpawnItemDropChanceFromEvent (spawn, event) {
      const chance = this.clampDecimalInputValue(event && event.target ? event.target.value : event, 0, 100)
      this.$set(spawn, 'itemRarity', chance / 100)
      this.setNativeInputValue(event, chance.toFixed(4).replace(/0+$/, '').replace(/\.$/, ''))
    },
    normalizeSpawnItemForSave (row) {
      const option = this.itemOptionForName(row.item)
      if (option) {
        row.itemID = option.id
        row.item = option.name
      } else {
        row.itemID = this.clampNumber(row.itemID, 0, 999999)
        if (row.itemID > 0 && this.itemNameByID[String(row.itemID)]) {
          row.item = this.itemNameByID[String(row.itemID)]
        }
      }
      row.itemRarity = row.itemID > 0 ? Math.min(Math.max(Number(row.itemRarity || 0), 0), 1) : 0
      if (row.itemID <= 0) {
        row.itemID = 0
        row.item = null
      }
    },
    defaultLevelRangeForMap () {
      const draftRange = this.normalizedDraftLevelRange()
      if (draftRange) return draftRange
      const rows = this.editRows.length ? this.editRows : (this.workflowView === 'live' ? (this.liveSpawnsByMap[this.activeMap] || []) : (this.activeBatch ? this.activeBatch.spawns || [] : []))
      if (rows.length) {
        return this.defaultLevelRangeForRows(rows)
      }
      return { min: 0, max: 0 }
    },
    defaultLevelRangeForRows (rows) {
      return {
        min: rows.reduce((min, spawn) => Math.min(min, Number(spawn.minLVL || 1)), 100),
        max: rows.reduce((max, spawn) => Math.max(max, Number(spawn.maxLVL || 1)), 1)
      }
    },
    openNewMapModal () {
      if (this.workflowView !== 'wip') return
      this.newMapModal = {
        visible: true,
        mapName: ''
      }
    },
    createNewMapDraft () {
      const mapName = String(this.newMapModal.mapName || '').trim()
      if (!mapName) return
      this.pendingNewMapName = mapName
      this.emit('saveSpawnDraft', {
        id: 0,
        mapName,
        spawns: [],
        newEmptyMap: true
      })
    },
    openAddSpawnModal (area) {
      if (!this.editMode) return
      this.ensureSpawnReferenceAnalysis()
      this.syncDraftLevelRangeForAddSpawn()
      this.addSpawnModal.area = area || (this.displayMode === 'water' ? 'surf' : 'land')
      this.addSpawnModal.search = ''
      this.addSpawnModal.selected = {}
      this.addSpawnModal.selectedOrder = []
      this.addSpawnModal.removedExisting = {}
      this.addSpawnModal.existingTimeOverrides = {}
      this.addSpawnModal.draggingDexID = null
      this.addSpawnModal.nextSelectionId = 1
      this.addSpawnModal.visible = true
    },
    syncDraftLevelRangeForAddSpawn () {
      if (!this.editRows.length) return
      const defaults = this.defaultLevelRangeForRows(this.editRows)
      this.setDraftLevelRange(defaults.min, defaults.max)
    },
    addAddSpawnSelection (dexID) {
      const numericDexID = Number(dexID || 0)
      if (!numericDexID || Number.isNaN(numericDexID)) return
      const dexKey = String(numericDexID)
      if (this.hideAddedAddSpawnPokemon) {
        if (this.activeAddSpawnSelectedDexIDs[dexKey]) return
        if (this.activeAddSpawnExistingDexIDs[dexKey]) return
      }
      const nextID = Number(this.addSpawnModal.nextSelectionId || 1)
      const key = dexKey + '-' + nextID
      this.addSpawnModal.nextSelectionId = nextID + 1
      this.$set(this.addSpawnModal.selected, key, {
        dexID: numericDexID,
        timeKeys: this.defaultAddSpawnTimeKeys()
      })
      this.addSpawnModal.selectedOrder.push(key)
    },
    removeAddSpawnSelection (selectionKey) {
      const key = String(selectionKey || '')
      if (!key) return
      this.$delete(this.addSpawnModal.selected, key)
      this.addSpawnModal.selectedOrder = this.addSpawnModal.selectedOrder.filter(entry => String(entry) !== key)
    },
    startAddSpawnDrag (pokemon, event) {
      const key = String(pokemon.dexID)
      this.addSpawnModal.draggingDexID = key
      if (event && event.dataTransfer) {
        event.dataTransfer.effectAllowed = 'move'
        event.dataTransfer.setData('text/plain', key)
      }
    },
    endAddSpawnDrag () {
      this.addSpawnModal.draggingDexID = null
    },
    dropAddSpawnPokemon (event) {
      const key = event && event.dataTransfer ? event.dataTransfer.getData('text/plain') : this.addSpawnModal.draggingDexID
      this.addAddSpawnSelection(key || this.addSpawnModal.draggingDexID)
      this.addSpawnModal.draggingDexID = null
    },
    isAddSpawnExistingRemoved (spawn) {
      return !!(this.addSpawnModal.removedExisting || {})[this.spawnKey(spawn)]
    },
    isAddSpawnExistingAutoRemoved (spawn) {
      return this.addSpawnExistingTimeKeys(spawn).length === 0
    },
    isAddSpawnExistingRemovalPending (spawn) {
      return this.isAddSpawnExistingRemoved(spawn) || this.isAddSpawnExistingAutoRemoved(spawn)
    },
    toggleAddSpawnExistingRemoved (spawn) {
      const key = this.spawnKey(spawn)
      if (this.isAddSpawnExistingRemoved(spawn)) {
        this.$delete(this.addSpawnModal.removedExisting, key)
        return
      }
      this.$set(this.addSpawnModal.removedExisting, key, true)
    },
    addSelectedSpawns () {
      if (!this.canApplyAddSpawnChanges) return
      if (this.selectedAddSpawnCount > 0 && !this.canUseAddSpawnLevelRange) {
        window.alert('Cannot add selected spawns. Fix the invalid Level Range first.')
        return
      }
      const removed = Object.assign({}, this.addSpawnModal.removedExisting || {})
      const timeOverrides = this.addSpawnModal.existingTimeOverrides || {}
      Object.keys(timeOverrides).forEach(key => {
        if (!this.normalizeTimeKeys(timeOverrides[key]).length) {
          removed[key] = true
        }
      })
      if (Object.keys(timeOverrides).length) {
        this.editRows.forEach(spawn => {
          const key = this.spawnKey(spawn)
          if (removed[key] || !Object.prototype.hasOwnProperty.call(timeOverrides, key)) return
          this.applyTimeKeysToSpawn(spawn, timeOverrides[key])
        })
      }
      if (Object.keys(removed).some(key => removed[key])) {
        this.editRows = this.editRows.filter(spawn => !removed[this.spawnKey(spawn)])
      }
      const selected = this.selectedAddSpawnPokemon
      selected.forEach(pokemon => {
        this.editRows.push(this.createSpawnForPokemon(pokemon, this.addSpawnModal.area))
      })
      this.addSpawnModal.visible = false
      this.addSpawnModal.selected = {}
      this.addSpawnModal.selectedOrder = []
      this.addSpawnModal.removedExisting = {}
      this.addSpawnModal.existingTimeOverrides = {}
      this.addSpawnModal.draggingDexID = null
      this.addSpawnModal.nextSelectionId = 1
    },
    createSpawnForPokemon (pokemon, area, preview) {
      const range = this.defaultLevelRangeForMap()
      const water = area === 'water' || area === 'surf'
      const itemID = Number((this.referenceData.itemDrops || {})[String(pokemon.dexID)] || 0)
      const chance = itemID > 0 ? Number((this.referenceData.itemDropChances || {})[String(itemID)] || 0) / 100 : 0
      const tier = this.referenceTiersForPokemon(pokemon.dexID)[0] || 'T1'
      const timeKeys = this.normalizeTimeKeys(pokemon.addSpawnTimeKeys || this.defaultAddSpawnTimeKeys())
      const timeRange = timeKeys.length ? this.timeRangeForKeys(timeKeys) : { start: 0, end: 0 }
      return {
        id: preview ? 0 : -Date.now() - this.editRows.length,
        map: this.activeMap,
        pokemon: pokemon.name,
        dexID: pokemon.dexID,
        type1: pokemon.type1 || '',
        type2: pokemon.type2 || '',
        minLVL: range.min,
        maxLVL: range.max,
        itemID: itemID,
        item: itemID > 0 ? this.itemNameByID[String(itemID)] || null : null,
        itemRarity: chance,
        memberOnly: false,
        rarity: this.rarityValueForTier(tier, water),
        area: water ? 'surf' : 'land',
        x1: 0,
        x2: 300,
        y1: 0,
        y2: 300,
        steps: 15,
        required_rod: 0,
        start: timeRange.start,
        end: timeRange.end,
        noTimeSelected: !timeKeys.length,
        forms: '0',
        formRarity: 0,
        approved: false,
        fishOnly: false
      }
    },
    deleteEditSpawn (spawn) {
      const key = this.spawnKey(spawn)
      this.editRows = this.editRows.filter(row => this.spawnKey(row) !== key)
    },
    deleteAllEditSpawns () {
      if (!window.confirm('Delete all Spawns from this edit draft?')) return
      this.editRows = []
    },
    setSpawnFishOnly (spawn, value) {
      this.$set(spawn, 'fishOnly', !!value)
      if (value) {
        spawn.x1 = 0
        spawn.x2 = 0
        spawn.y1 = 0
        spawn.y2 = 0
        if (Number(spawn.required_rod || 0) <= 0) spawn.required_rod = 1
      } else {
        spawn.x1 = 0
        spawn.x2 = 300
        spawn.y1 = 0
        spawn.y2 = 300
      }
    },
    updateSpawnRarityFromTier (spawn, tier) {
      if (this.censorRarityTiers) return
      this.$set(spawn, 'rarity', this.clampDecimalInputValue(this.rarityValueForTier(tier, this.isWaterSpawn(spawn)), 0, 1))
    },
    preventEditInputWheel (event) {
      if (event && event.target && typeof event.target.blur === 'function') {
        event.target.blur()
      }
    },
  }
}
